const LeadDraftHook = {
  mounted() {
    this.draftKey = this.el.dataset.draftKey;
    this.draftEnabled = this.el.dataset.draftEnabled === "true";
    this.unsaved = this.el.dataset.unsaved === "true";

    this.beforeUnloadHandler = (event) => {
      if (!this.unsaved) return;
      event.preventDefault();
      event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
      return event.returnValue;
    };

    this.clickHandler = (event) => {
      if (!this.unsaved) return;
      const link = event.target.closest("a[href]");
      if (!link) return;
      if (link.dataset.skipUnsavedWarning === "true") return;

      const href = link.getAttribute("href");
      if (!href || href.startsWith("#")) return;
      if (link.getAttribute("target") === "_blank") return;

      const confirmLeave = window.confirm("You have unsaved changes. Leave this page?");
      if (!confirmLeave) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };

    document.addEventListener("click", this.clickHandler, true);
    this.syncUnsavedHandlers();

    if (this.draftEnabled) {
      this.restoreFromLocal();
    }

    this.handleEvent("draft_store", ({ key, data, saved_at }) => {
      const storeKey = key || this.draftKey;
      if (!storeKey || !data) return;
      const payload = { data, saved_at };
      localStorage.setItem(storeKey, JSON.stringify(payload));
      window.dispatchEvent(
        new CustomEvent("lead-draft:updated", {
          detail: { key: storeKey, ...payload },
        })
      );
    });

    this.handleEvent("draft_clear", ({ key }) => {
      const storeKey = key || this.draftKey;
      if (!storeKey) return;
      localStorage.removeItem(storeKey);
      window.dispatchEvent(new CustomEvent("lead-draft:updated", { detail: null }));
    });
  },

  updated() {
    this.draftEnabled = this.el.dataset.draftEnabled === "true";
    this.unsaved = this.el.dataset.unsaved === "true";
    this.syncUnsavedHandlers();
  },

  destroyed() {
    document.removeEventListener("click", this.clickHandler, true);
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },

  syncUnsavedHandlers() {
    if (this.unsaved) {
      window.addEventListener("beforeunload", this.beforeUnloadHandler);
    } else {
      window.removeEventListener("beforeunload", this.beforeUnloadHandler);
    }
  },

  restoreFromLocal() {
    if (!this.draftKey) return;

    const raw = localStorage.getItem(this.draftKey);
    if (!raw) return;

    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (_e) {
      return;
    }

    if (!parsed || !parsed.data) return;

    const localSavedAt = parsed.saved_at ? new Date(parsed.saved_at) : null;
    const serverSavedAt = this.el.dataset.draftSavedAt ? new Date(this.el.dataset.draftSavedAt) : null;

    if (!serverSavedAt || (localSavedAt && localSavedAt > serverSavedAt)) {
      this.pushEvent("restore_draft", {
        lead: parsed.data,
        saved_at: parsed.saved_at || new Date().toISOString()
      });
    }
  }
};

export default LeadDraftHook;
